import { createFileRoute } from '@tanstack/react-router';
import { FileManagerPage } from '@/components/features/files/FileManagerPage';
import { MobileFileManager } from '@/components/features/files/MobileFileManager';

export const Route = createFileRoute('/_authenticated/files')({
  component: FileManagerRoute,
});

function FileManagerRoute() {
  return (
    <>
      <div className="hidden md:block">
        <FileManagerPage />
      </div>
      <div className="md:hidden">
        <MobileFileManager />
      </div>
    </>
  );
}
